import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { Col, Container, Row } from "react-bootstrap";
import { constructionType, genderData, schemesData, statesName } from "../../../../TCPForms/data";

const SubStep2 = ({ formData, handleSubTabChange, t, applicationFlow, officesList, isAssignedLTP, applicationData, approvedLayout,isEmployee,isApproved }) => {
  const defaultValues = {
    ...formData,
  };
  console.log("officesList", officesList, formData, applicationFlow);

  const { handleSubmit, control, reset, watch, setValue } = useForm({ defaultValues });

  // const isApplicantPhoto = documents.some((item) => item.documentType == "applicantPhoto");
  // const isSignature = documents.some((item) => item.documentType == "signature");
  useEffect(() => {
    const newProperties = [
      {
        ...formData?.descriptionOfLand?.properties?.[0],
        plotArea: applicationData?.descriptionOfLand?.landArea,
        propertyNo: applicationData?.descriptionOfLand?.plotNo,
      },
    ];
    reset({
      ...formData,
      approvedLayout: approvedLayout,
      landInfo: {
        address: {
          ...formData?.landInfo?.address,
          tenantId: formData?.landInfo?.tenantId,
          // locality: {
          //   code: formData?.selectedOffice?.split(" ")[0],
          // },
        },
        owners: applicationData?.landInfo?.owners,
        tenantId: applicationData?.landInfo?.tenantId,
      },
      descriptionOfLand: {
        properties: newProperties,
      },
    });
    setValue("documents", applicationData?.documents);
  }, [applicationData]);
  const onSubmit = (data) => {
    console.log("logFromSub2", data);

    handleSubTabChange(2, data);
  };
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("LABEL_APPLICANT_DETAILS")}</h2>
          </div>

          <Container fluid className="formInputContainer">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_NAME")}
                  placeholder={t("LABEL_ENTER_NAME")}
                  name="landInfo.owners[0].name"
                  type="textInput"
                  maxLength={30}
                  mandatory

                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  isApproved={true}
                  disabled={
                    Boolean(isAssignedLTP) || Boolean(formData?.landInfo?.owners?.[0]?.name) || Boolean(applicationData?.landInfo?.owners?.[0]?.name || isEmployee || isApproved)
                  } // Add disabled here
                />
              </Col>

              <Col>
                <InputWrapper
                  control={control}
                  name="landInfo.owners[0].fatherOrHusbandName"
                  label={t("LABEL_FATHER_NAME")}
                  placeholder={t("LABEL_ENTER_FATHER_NAME")}
                  type="textInput"
                  maxLength={30}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  isApproved={true}
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.landInfo?.owners?.[0]?.fatherOrHusbandName) ||
                    Boolean(applicationData?.landInfo?.owners?.[0]?.fatherOrHusbandName ||isEmployee || isApproved)
                  } // Add disabled here
               />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Gender")}
                  placeholder={t("Gender")}
                  // defaultValue={ownerInfo?.gender}
                  name="landInfo.owners[0].gender"
                  type="selectInput"
                  data={genderData}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select the gender",
                    },
                  }}
                  isApproved={true}
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.landInfo?.owners?.[0]?.gender) ||
                    Boolean(applicationData?.landInfo?.owners?.[0]?.gender || isEmployee || isApproved)
                  } // Add disabled here
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  name="landInfo.owners[0].mobileNumber"
                  // defaultValue={ownerInfo?.mobileNumber}
                  label={t("LABEL_MOBILE_NUMBER")}
                  placeholder={t("LABEL_ENTER_MOBILE_NUMBER")}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("MobileNo"),
                      message: "Please enter valid mobile no",
                    },
                  }}
                  maxLength={10}
                  isApproved={true}
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.landInfo?.owners?.[0]?.mobileNumber) ||
                    Boolean(applicationData?.landInfo?.owners?.[0]?.mobileNumber ||isEmployee || isApproved)
                  } // Add disabled here
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  name="landInfo.owners[0].emailId"
                  // defaultValue={ownerInfo?.emailId}
                  label={t("LABEL_EMAIL_ID")}
                  placeholder={t("LABEL_ENTER_EMAIL_ID")}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Email"),
                      message: "Please enter valid email id",
                    },
                  }}
                  isApproved={true}
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.landInfo?.owners?.[0]?.emailId) ||
                    Boolean(applicationData?.landInfo?.owners?.[0]?.emailId ||isEmployee || isApproved)
                  } // Add disabled here
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  name="landInfo.owners[0].aadhaarNumber"
                  // defaultValue={ownerInfo?.aadhaarNumber}
                  label={t("LABEL_AADHAR_CARD")}
                  placeholder={t("LABEL_ENTER_AADHAR_CARD")}
                  type="textInput"
                  mandatory
                  validation={{
                    pattern: {
                      value: Digit.Utils.getPattern("AadharNo"),
                      message: "Please enter valid Aadhaar no",
                    },
                  }}
                  maxLength={12}
                  isApproved={true}
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.landInfo?.owners?.[0]?.aadhaarNumber) ||
                    Boolean(applicationData?.landInfo?.owners?.[0]?.aadhaarNumber || isEmployee || isApproved)
                  } // Add disabled here
                />
              </Col>
            </Row>

            {/* <Row>
              <Col>
                <InputWrapper
                  control={control}
                  name="descriptionOfLand.properties[0].propertyNo"
                  // defaultValue={descriptionOfLand?.propertyNo}
                  label={t("LABEL_PROPERTY_NO")}
                  placeholder={t("LABEL_ENTER_PROPERTY_NO")}
                  type="textInput"
                  mandatory
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.descriptionOfLand?.properties[0]?.propertyNo) ||
                    Boolean(applicationData?.descriptionOfLand?.plotNo)
                  } // Add disabled here
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  name="descriptionOfLand.properties[0].plotArea"
                  // defaultValue={descriptionOfLand?.plotArea}
                  label={t("LABEL_PLOT_AREA")}
                  placeholder={t("LABEL_ENTER_PLOT_AREA")}
                  type="textInput"
                  mandatory
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.descriptionOfLand?.properties[0]?.plotArea) ||
                    Boolean(applicationData?.descriptionOfLand?.landArea)
                  } // Add disabled here
                />
              </Col>
            </Row> */}

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  name="landInfo.owners[0].correspondenceAddress.town"
                  // defaultValue={ownerInfo?.ownerInfo?.correspondenceAddress?.town}
                  label={t("LABEL_CITY")}
                  placeholder={t("LABEL_ENTER_CITY")}
                  type="textInput"
                  mandatory
                  maxLength={25}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isApproved={true}
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.landInfo?.owners?.[0]?.correspondenceAddress?.town) ||
                    Boolean(applicationData?.landInfo?.owners?.[0]?.correspondenceAddress?.town || isEmployee || isApproved)
                  } // Add disabled here
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  name="landInfo.owners[0].correspondenceAddress.address"
                  // defaultValue={ownerInfo?.correspondenceAddress?.address}
                  label={t("LABEL_ADDRESS")}
                  placeholder={t("LABEL_ENTER_ADDRESS")}
                  type="textInput"
                  mandatory
                  maxLength={150}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Address"),
                      message: "Please enter valid Address",
                    },
                  }}
                  isApproved={true}
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address) ||
                    Boolean(applicationData?.landInfo?.owners?.[0]?.correspondenceAddress?.address || isEmployee || isApproved)
                  } // Add disabled here
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_STATE")}
                  placeholder={t("LABEL_ENTER_STATE")}
                  name="landInfo.owners[0].correspondenceAddress.state"
                  // defaultValue={ownerInfo?.state}
                  type="selectInput"
                  data={statesName}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isApproved={true}
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.landInfo?.owners?.[0]?.correspondenceAddress?.state) ||
                    Boolean(applicationData?.landInfo?.owners?.[0]?.correspondenceAddress?.state || isEmployee || isApproved)
                  } // Add disabled here
                 />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  name="landInfo.owners[0].correspondenceAddress.pinno"
                  label={t("LABEL_PIN_CODE")}
                  placeholder={t("LABEL_ENTER_PIN_CODE")}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Pincode"),
                      message: "Please enter valid Pin Code",
                    },
                  }}
                  maxLength={6}
                  isApproved={true}
                  // defaultValue={ownerInfo?.pinno}
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno) ||
                    Boolean(applicationData?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno || isEmployee || isApproved)
                  } // Add disabled here
                />
              </Col>
            </Row>

            {!isAssignedLTP && (
              <Row>
                {/* {!isSignature && (
                  <Col>
                    <FileUploader2
                      name="signature"
                      label={t("LABEL_ATTACH_SIGNATURE")}
                      validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                      isMandatory
                      required
                      tab={2}
                    />
                  </Col>
                )} */}
                {/* 
                {!isApplicantPhoto && (
                  <Col>
                    <FileUploader2
                      name="applicantPhoto"
                      label={t("LABEL_APPLICANT_PHOTO")}
                      validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                      isMandatory
                      required
                      tab={2}
                    />
                  </Col>
                )} */}
              </Row>
            )}
          </Container>
          <div className="footerContainer2">
          {!isEmployee && !isApproved && (<div className="buttonWrapper">
         <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                onClick={() => handleSubTabChange(0)}
              />
            <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="submit"
                sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
              />
            </div>)}
          </div>
        </div>
      </form>
    </section>
  );
};

export default SubStep2;
